import { render, staticRenderFns } from "./AccountSettingsEditPasswordForm.vue?vue&type=template&id=6b7b71c5&"
import script from "./AccountSettingsEditPasswordForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsEditPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports